<template>
  <div class="main">
    <a-card :loading="loading" style="border-radius: 20px;" :bordered="false">
      <div class="actions">
        <h3 style="font-size: 28px; line-height: 45px">Users</h3>
      </div>
      <div style="display: flex; justify-content: flex-end; margin-bottom: 20px">
        <a-button @click="showAddUserModal" style="
          width: 159px;
          height: 38px;
          border-raduis: 5px;
          background: #418a49;
          color: #fff;
        " icon="plus">
          Add User
        </a-button>
      </div>
      <div>
        <div class="card-container">
          <a-tabs type="card">
            <a-tab-pane key="1">
              <span slot="tab">
                Clients Users
              </span>
              <ClientUsersTable :users="ClientUsers.data" @tableChange="handleTableChange" :tableLoading="tableLoading"
                @triggerEditProfile="showEditProfileModal" @triggerPassChange="showChangePassword" />
            </a-tab-pane>
            <a-tab-pane key="2">
              <span slot="tab">
                Distribution Centres
              </span>
              <DistroCentreUsersTable :users="distroUsers.data" @tableChange="handleTableChange"
                :tableLoading="tableLoading" @triggerEditProfile="showEditProfileModal"
                @triggerPassChange="showChangePassword" />
            </a-tab-pane>
            <a-tab-pane key="3">
              <span slot="tab">
                Warehouses
              </span>
              <WarehouseUsersTable :users="warehouseUsers.data" @tableChange="handleTableChange"
                :tableLoading="tableLoading" @triggerEditProfile="showEditProfileModal"
                @triggerPassChange="showChangePassword" />
            </a-tab-pane>
            <a-tab-pane key="4">
              <span slot="tab">
                Customers
              </span>
              <UserCustomersTable :users="customerUsers.data" @tableChange="handleTableChange"
                :tableLoading="tableLoading" @triggerEditProfile="showEditProfileModal"
                @triggerPassChange="showChangePassword" />
            </a-tab-pane>
          </a-tabs>
        </div>
      </div>
      <a-modal class="modalStyle" :visible="addUserVisible" :footer="null" @cancel="handleAddUserCancel">
        <div style="display: flex; justify-content: center">
          <img class="img_size"
            src="../../assets/img/illo_sm_employees_3_3554528_c_9_f_99_ede_44_e_2797833410_a_520.svg" />
        </div>
        <p style="
          display: flex;
          justify-content: center;
          font-weight: bolder;
          padding-top: 10px;
        ">
          Add User
        </p>
        <div>
          <a-form-model ref="addUserForm" :model="addUserModel" :rules="rules">
            <a-row>
              <a-col :span="10" :offset="1">
                <a-form-model-item label="Name" ref="name" prop="name">
                  <a-input class="" v-model="addUserModel.name" />
                </a-form-model-item>
              </a-col>
              <a-col :span="10" :offset="2">
                <a-form-model-item label="Email" ref="email" prop="email">
                  <a-input class="" v-model="addUserModel.email" />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="10" :offset="1">
                <a-form-model-item label="Password" ref="password" prop="password">
                  <a-input class="" v-model="addUserModel.password" type="password" />
                </a-form-model-item>
              </a-col>
              <a-col :span="10" :offset="2">
                <a-form-model-item label="Phone Number" ref="phoneNumber" prop="phoneNumber">
                  <a-input class="" v-model="addUserModel.phoneNumber" />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="10" :offset="1">
                <a-form-model-item label="Gender" ref="gender" prop="gender">
                  <a-select v-model="addUserModel.gender" placeholder="please select your gender">
                    <a-select-option value="male"> Male </a-select-option>
                    <a-select-option value="female"> Female </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="22" :offset="1">
                <a-form-model-item label="Roles" ref="roles" prop="roles">
                  <a-select mode="multiple" v-model="userRoles.roles" placeholder="Select user roles"
                    @change="handleRoleChange" @deselect="resetRoles">
                    <a-select-option v-for="role in roles" :key="role.id">
                      {{ role.name }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="10" :offset="1" v-if="retailRole">
                <a-form-model-item label="Retail Centre" ref="retailCenters" prop="retailCenters">
                  <a-select v-model="userRoles.retailCentreId" placeholder="Select Retail Centre">
                    <template>
                      <a-select-option :value="retailCenter.id" v-for="retailCenter in retailCenters"
                        :key="retailCenter.id">
                        {{ retailCenter.name }}
                      </a-select-option>
                    </template>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="11" :offset="1" v-if="distributionRole">
                <a-form-model-item label="Distribution Centre" ref="distroCenters" prop="distroCenters">
                  <a-select v-model="userRoles.distributionCentreId">
                    <a-select-option :value="distroCenter.id" v-for="distroCenter in distroCenters.data"
                      :key="distroCenter.id">
                      {{ distroCenter.name }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="10" :offset="1" v-if="warehouseRole">
                <a-form-model-item label="Warehouse" ref="warehouse" prop="warehouse">
                  <a-select v-model="userRoles.warehouseId" placeholder="Select Retail Centre">
                    <a-select-option :value="warehouse.id" v-for="warehouse in warehouses.data" :key="warehouse.id">
                      {{ warehouse.name }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>

            <div style="display: flex; justify-content: center; padding-bottom: 10px">
              <a-spin class="spinner" :spinning="loading" />
            </div>

            <a-form-model-item style="
              display: flex;
              justify-content: center;
              align-items: center;
              padding-top: 40px;
            ">
              <a-button @click="handleAddUserSubmit" :loading="loading" style="
                background: #418a49;
                height: 59px;
                color: #fff;
                width: 263px;
                border-radius: 5px;
              ">
                Add User
              </a-button>
            </a-form-model-item>
          </a-form-model>
        </div>
      </a-modal>
      <a-modal class="modalStyle" :visible="editUserVisible" :footer="null" @cancel="handleEditUserCancel">
        <div style="display: flex; justify-content: center">
          <img class="img_size"
            src="../../assets/img/illo_sm_employees_3_3554528_c_9_f_99_ede_44_e_2797833410_a_520.svg" />
        </div>
        <p style="
          display: flex;
          justify-content: center;
          font-weight: bolder;
          padding-top: 10px;
        ">
          Edit User?
        </p>
        <div>
          <a-form-model ref="editUserForm" :model="editUserModel" :rules="rules">
            <a-row>
              <a-col :span="10" :offset="1">
                <a-form-model-item label="Name" ref="name" prop="name">
                  <a-input class="" v-model="editUserModel.name" />
                </a-form-model-item>
              </a-col>
              <a-col :span="10" :offset="2">
                <a-form-model-item label="Phone Number" ref="phoneNumber" prop="phoneNumber">
                  <a-input class="" v-model="editUserModel.phoneNumber" />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="22" :offset="1">
                <a-form-model-item label="Gender" ref="gender" prop="gender">
                  <a-select v-model="editUserModel.gender" placeholder="please select your gender">
                    <a-select-option value="male"> Male </a-select-option>
                    <a-select-option value="female"> Female </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="22" :offset="1">
                <a-form-model-item label="Roles" ref="roles" prop="roles">
                  <a-select mode="multiple" v-model="editUserModel.roles" placeholder="Select user roles"
                    @change="handleUpdateRoleChange" @deselect="resetUpdateRoles">
                    <a-select-option v-for="role in roles" :key="role.id">
                      {{ role.name }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="10" :offset="1" v-if="editUserModel.retailRole">
                <a-form-model-item label="Retail Centre" ref="retailCenters" prop="retailCenters">
                  <a-select v-model="editUserModel.retailCentreId" placeholder="Select Retail Centre">
                    <template>
                      <a-select-option :value="retailCenter.id" v-for="retailCenter in retailCenters"
                        :key="retailCenter.id">
                        {{ retailCenter.name }}
                      </a-select-option>
                    </template>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="11" :offset="1" v-if="editUserModel.distributionRole">
                <a-form-model-item label="Distribution Centre" ref="distroCenters" prop="distroCenters">
                  <a-select v-model="editUserModel.distributionCentreId">
                    <a-select-option :value="distroCenter.id" v-for="distroCenter in distroCenters.data"
                      :key="distroCenter.id">
                      {{ distroCenter.name }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="10" :offset="1" v-if="editUserModel.warehouseRole">
                <a-form-model-item label="Warehouse" ref="warehouse" prop="warehouse">
                  <a-select v-model="editUserModel.warehouseId" placeholder="Select Retail Centre">
                    <a-select-option :value="warehouse.id" v-for="warehouse in warehouses.data" :key="warehouse.id">
                      {{ warehouse.name }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>

            <div style="display: flex; justify-content: center; padding-bottom: 10px">
              <a-spin class="spinner" :spinning="loading" />
            </div>

            <a-form-model-item style="
              display: flex;
              justify-content: center;
              align-items: center;
              padding-top: 40px;
            ">
              <a-button @click="handleEditUserSubmit" :loading="loading" style="
                background: #418a49;
                height: 59px;
                color: #fff;
                width: 263px;
                border-radius: 5px;
              ">
                Edit User
              </a-button>
            </a-form-model-item>
          </a-form-model>
        </div>
      </a-modal>
      <a-modal class="modalStyle" :visible="changePasswordVisible" :footer="null" @cancel="handleChangePasswordCancel">
        <div style="display: flex; justify-content: center">
          <img class="img_size"
            src="../../assets/img/illo_sm_employees_3_3554528_c_9_f_99_ede_44_e_2797833410_a_520.svg" />
        </div>
        <p style="
          display: flex;
          justify-content: center;
          font-weight: bolder;
          padding-top: 10px;
        ">
          Change Password?
        </p>
        <div>
          <a-form-model ref="changePasswordForm" :model="changePassswordModel" :rules="rules">
            <a-row>
              <a-col :span="22" :offset="1">
                <a-form-model-item label="New Password" ref="newPassword" prop="newPassword">
                  <a-input class="" type="password" v-model="changePassswordModel.newPassword" />
                </a-form-model-item>
              </a-col>
              <a-col :span="22" :offset="1">
                <a-form-model-item label="Confirm Password" ref="confirmPassword" prop="confirmPassword">
                  <a-input class="" type="password" v-model="changePassswordModel.confirmPassword" />
                </a-form-model-item>
              </a-col>
            </a-row>

            <div style="display: flex; justify-content: center; padding-bottom: 10px">
              <a-spin class="spinner" :spinning="loading" />
            </div>

            <a-form-model-item style="
              display: flex;
              justify-content: center;
              align-items: center;
              padding-top: 40px;
            ">
              <a-button @click="handleChangePasswordSubmit" :loading="loading" style="
                background: #418a49;
                height: 59px;
                color: #fff;
                width: 263px;
                border-radius: 5px;
              ">
                Change Password
              </a-button>
            </a-form-model-item>
          </a-form-model>
        </div>
      </a-modal>
    </a-card>
  </div>
</template>

<script>
import moment from "moment";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Users",
  components: {
    ClientUsersTable: () => import("./tables/ClientUsersTable.vue"),
    DistroCentreUsersTable: () => import("./tables/DistroCentreUsers.vue"),
    WarehouseUsersTable: () => import("./tables/WarehouseUsersTable.vue"),
    UserCustomersTable: () => import("./tables/UserCustomersTable.vue"),
  },
  data() {
    return {
      users: [],
      tableLoading: false,
      params: {
        page: 1,
        perPage: 20,
        searchBy: {},
        sortBy: {},
      },
      addUserModel: {
        name: "",
        password: "",
        email: "",
        phoneNumber: "",
        gender: "",
      },
      retailCenters: [],
      userRoles: {
        roles: [],
        retailCentreId: "",
        distributionCentreId: "",
        warehouseId: "",
        clientId: "",
      },
      retailRole: false,
      distributionRole: false,
      warehouseRole: false,
      clientRole: false,
      editUserModel: {
        name: "",
        phoneNumber: "",
        gender: "",
        retailRole: false,
        distributionRole: false,
        warehouseRole: false,
        clientRole: false,
        roles: [],
        retailCentreId: "",
        distributionCentreId: "",
        warehouseId: "",
        clientId: "",
      },
      changePassswordModel: {
        newPassword: "",
        confirmPassword: "",
      },
      selectedUser: {},
      addUserVisible: false,
      editUserVisible: false,
      disableUserVisible: false,
      changePasswordVisible: false,
      dateFormat: "DD/MM/YYYY",
      startDate: moment(),
      endDate: moment(),
      loading: false,
      rules: {
        name: [
          { required: true, message: "Please enter name", trigger: "change" },
        ],
        password: [
          {
            required: true,
            message: "Please enter password",
            trigger: "change",
          },
        ],
        newPassword: [
          {
            required: true,
            message: "Please enter new password",
            trigger: "change",
          },
        ],
        confirmPassword: [
          {
            required: true,
            message: "Please enter confirm password",
            trigger: "change",
          },
        ],
        email: [
          { required: true, message: "Please enter email", trigger: "change" },
          {
            pattern: new RegExp(
              /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
            ),
            message: "Please enter valid email",
            trigger: "change",
          },
        ],
        phoneNumber: [
          {
            required: true,
            message: "Please enter phoneNumber",
            trigger: "change",
          },
        ],
        gender: [
          { required: true, message: "Please enter gender", trigger: "change" },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["IsAgentProfileAvailable"]),
    roles() {
      let roles = this.$store.getters["role/GetRoles"];
      return roles.slice(2);
    },
    warehouses() {
      return this.$store.getters["generic/GetWarehouses"];
    },
    clients() {
      return this.$store.getters["generic/GetClients"];
    },
    ClientUsers() {
      return this.$store.getters["generic/GetClientUsers"];
    },
    distroUsers() {
      return this.$store.getters["generic/GetDistroUsers"];
    },
    warehouseUsers() {
      return this.$store.getters["generic/GetWarehouseUsers"];
    },
    customerUsers() {
      return this.$store.getters["generic/GetCustomerUsers"];
    },
    distroCenters() {
      return this.$store.getters["distroCenter/GetDistroCenters"];
    },
  },
  methods: {
    handleRoleChange(value) {
      // console.log("selected ----", value);
      let selectedRoles = value;
      this.checkRoleType(selectedRoles);
    },
    handleUpdateRoleChange(value) {
      // console.log("selected ----", value);
      let selectedRoles = value;
      this.checkUpdateRoleType(selectedRoles);
    },
    checkRoleType: function (selectedRoles) {
      let VUE_APP_RETAIL_SALES_AGENT_ROLE = "303415A369B3527610CED0C66B544AD0";
      let VUE_APP_RETAIL_MANAGER_ROLE = "84C99B4ADEAFCBE9B0765E5257F60A8D";
      let VUE_APP_DISTRO_SALES_MANAGER_ROLE =
        "6EBD182B94439A01262E56A29F24A31C";
      let VUE_APP_DISTRO_MANAGER_ROLE = "35EBEBE25B24C9F09518F17BBFA1EA53";
      let VUE_APP_DISTRO_DISPATCHER_ROLE = "A7755E8F0C3062614273123F2F1E9D59";
      let VUE_APP_WAREHOUSE_FULFILL_MANAGER_ROLE =
        "2AF103DB453AD67FC7D7E7DB67C00D2A";
      let VUE_APP_WAREHOUSE_MANAGER_ROLE = "5E90C5825C5241D3919E5DCA454A6CBF";
      let VUE_APP_WAREHOUSE_SALES_MANAGER_ROLE =
        "9BAFE2CBF42A8ECA038D3DF632EF1627";
      let VUE_APP_CLIENT_ROLE = "79b2799f8ae34b6eb3c207f302ac0a73";
      if (selectedRoles)
        selectedRoles.forEach((role) => {
          if (
            role === VUE_APP_RETAIL_MANAGER_ROLE ||
            role === VUE_APP_RETAIL_SALES_AGENT_ROLE
          ) {
            this.retailRole = true;
            return "retail";
          } else if (
            role === VUE_APP_DISTRO_SALES_MANAGER_ROLE ||
            role === VUE_APP_DISTRO_MANAGER_ROLE ||
            role === VUE_APP_DISTRO_DISPATCHER_ROLE
          ) {
            this.distributionRole = true;
            return "distro";
          } else if (
            role === VUE_APP_WAREHOUSE_MANAGER_ROLE ||
            role === VUE_APP_WAREHOUSE_SALES_MANAGER_ROLE ||
            role === VUE_APP_WAREHOUSE_FULFILL_MANAGER_ROLE
          ) {
            this.warehouseRole = true;
            return "warehouse";
          } else if (role === VUE_APP_CLIENT_ROLE) {
            this.clientRole = true;
          }
        });
      return 0;
    },
    checkUpdateRoleType: function (selectedRoles) {
      let VUE_APP_RETAIL_SALES_AGENT_ROLE = "303415A369B3527610CED0C66B544AD0";
      let VUE_APP_RETAIL_MANAGER_ROLE = "84C99B4ADEAFCBE9B0765E5257F60A8D";
      let VUE_APP_DISTRO_SALES_MANAGER_ROLE =
        "6EBD182B94439A01262E56A29F24A31C";
      let VUE_APP_DISTRO_MANAGER_ROLE = "35EBEBE25B24C9F09518F17BBFA1EA53";
      let VUE_APP_DISTRO_DISPATCHER_ROLE = "A7755E8F0C3062614273123F2F1E9D59";
      let VUE_APP_WAREHOUSE_FULFILL_MANAGER_ROLE =
        "2AF103DB453AD67FC7D7E7DB67C00D2A";
      let VUE_APP_WAREHOUSE_MANAGER_ROLE = "5E90C5825C5241D3919E5DCA454A6CBF";
      let VUE_APP_WAREHOUSE_SALES_MANAGER_ROLE =
        "9BAFE2CBF42A8ECA038D3DF632EF1627";
      let VUE_APP_CLIENT_ROLE = "79b2799f8ae34b6eb3c207f302ac0a73";
      if (selectedRoles)
        selectedRoles.forEach((role) => {
          if (
            role === VUE_APP_RETAIL_MANAGER_ROLE ||
            role === VUE_APP_RETAIL_SALES_AGENT_ROLE
          ) {
            this.editUserModel.retailRole = true;
            return "retail";
          } else if (
            role === VUE_APP_DISTRO_SALES_MANAGER_ROLE ||
            role === VUE_APP_DISTRO_MANAGER_ROLE ||
            role === VUE_APP_DISTRO_DISPATCHER_ROLE
          ) {
            this.editUserModel.distributionRole = true;
            return "distro";
          } else if (
            role === VUE_APP_WAREHOUSE_MANAGER_ROLE ||
            role === VUE_APP_WAREHOUSE_SALES_MANAGER_ROLE ||
            role === VUE_APP_WAREHOUSE_FULFILL_MANAGER_ROLE
          ) {
            this.editUserModel.warehouseRole = true;
            return "warehouse";
          } else if (role === VUE_APP_CLIENT_ROLE) {
            this.editUserModel.clientRole = true;
          }
        });
      return 0;
    },
    resetUpdateRoles() {
      if (this.editUserModel.roles) {
        this.editUserModel.retailRole = false;
        this.editUserModel.warehouseRole = false;
        this.editUserModel.distributionRole = false;
      }
    },
    resetRoles() {
      if (this.userRoles.roles) {
        this.retailRole = false;
        this.warehouseRole = false;
        this.distributionRole = false;
      }
    },
    ...mapActions([
      "getClientUsersRequests",
      "addNewClientUser",
      "updateClientUser",
      "setCustomerInfo",
      "setAgentProfile",
      "changeUserPassword",
    ]),
    onChange(date, dateString) {
      // console.log(date, dateString);
      this.startDate = dateString[0];
      this.endDate = dateString[1];
      // console.log("startDate | ", this.startDate);
      // console.log("endDate | ", this.endDate);
    },
    moment,
    showEditProfileModal(user) {
      this.selectedUser = user;
      this.editUserModel.name = user.name;
      this.editUserModel.phoneNumber = user.phoneNumber;
      this.editUserModel.gender = user.gender;
      if (user.roleIds) {
        this.roles.forEach((role) => {
          user.roleIds.forEach((dbrole) => {
            if (role.id === dbrole) {
              this.editUserModel.roles.push(role);
              this.handleUpdateRoleChange(this.editUserModel.roles);
            }
          });
        });
      } else {
        this.editUserModel.roles = [];
        this.handleUpdateRoleChange(this.editUserModel.roles);
      }
      this.editUserModel.retailCentreId = user.retailCentreId;
      this.editUserModel.distributionCentreId = user.distributionCentreId;
      this.editUserModel.warehouseId = user.warehouseId;
      this.editUserModel.clientId = user.clientId;
      this.editUserVisible = true;
      // this.setCustomerInfo(data)
      // this.$router.push('/customer-history').catch(()=>{});
    },
    showChangePassword(user) {
      this.selectedUser = user;
      this.changePasswordVisible = true;
    },

    showAddUserModal() {
      this.addUserVisible = true;
    },
    handleChangePasswordCancel() {
      this.changePasswordVisible = false;
    },
    handleAddUserCancel() {
      // console.log('Clicked cancel button');
      this.addUserVisible = false;
    },
    handleEditUserCancel() {
      // console.log('Clicked cancel button');
      this.editUserVisible = false;
    },
    handleAddUserSubmit() {
      this.$refs.addUserForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          // console.log("newAgent | ", this.newAgent)
          console.log("IsAgentProfileAvailable | ", this.IsAgentProfileAvailable)
          let userRoles = [];
          if (this.userRoles.roles) {
            userRoles = this.userRoles.roles
          } else {
            userRoles.push(process.env.VUE_APP_CLIENT_USER_ROLE);
          }
    
          let request_data = {
            data: {
              name: this.addUserModel.name,
              email: this.addUserModel.email,
              password: this.addUserModel.password,
              phoneNumber: this.addUserModel.phoneNumber,
              gender: this.addUserModel.gender,
              roles: userRoles,
              isActive: true,
              clientId: this.IsAgentProfileAvailable.clientId
            },
            isClient: false,
            
          };
          
          if (this.userRoles.distributionCentreId) {
            request_data.data.distributionCentreId = Number(
              this.userRoles.distributionCentreId
            );
          }
          if (this.userRoles.retailCentreId) {
            request_data.data.retailCentreId = Number(
              this.userRoles.retailCentreId
            );
          }
          if (this.userRoles.warehouseId) {
            request_data.data.warehouseId = Number(this.userRoles.warehouseId);
          }
          if (this.userRoles.clientId) {
            request_data.isClient = true;
          }

          this.addNewClientUser(request_data).then(
            (response) => {
              this.loading = false;
              if (response.status === 200) {
                this.$store.dispatch("distroCenter/FetchDistroCenters", { limit: -1 });
                this.$store.dispatch("generic/FetchClients", { perPage: -1 });
                this.$store.dispatch("generic/FetchUsers", { perPage: -1 });
                this.$store.dispatch("generic/FetchWarehouses", { limit: -1 });
                this.addUserVisible = false;
                this.showSuccessAlert("New user added successfully");
                this.$refs.addUserForm.resetFields();
              } else {
                this.showErrorAlert(response.data.messages);
              }
            },
            (error) => {
              this.loading = false;
              this.showErrorAlert(JSON.stringify(error));
            }
          );
        } else {
          // console.log('error submit!!');
          this.loading = false;
          return false;
        }
      });
    },

    handleEditUserSubmit() {
      this.$refs.editUserForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          // console.log("newAgent | ", this.newAgent)
          // console.log("IsAgentProfileAvailable | ", this.IsAgentProfileAvailable)
          let userRoles = [];
          if (this.editUserModel.roles) {
            this.editUserModel.roles.forEach((role) => {
              userRoles.push(role.id);
            });
          } else {
            userRoles.push(process.env.VUE_APP_CLIENT_USER_ROLE);
          }
          let request_data = {
            userId: this.selectedUser.id,
            isClient: false,
            data: {
              id: this.selectedUser.id,
              name: this.editUserModel.name,
              description: this.selectedUser.description,
              phoneNumber: this.editUserModel.phoneNumber,
              gender: this.editUserModel.gender,
              roles: this.editUserModel.roles,
              distributionCentreId: this.editUserModel.distributionCentreId,
              retailCentreId: this.editUserModel.retailCentreId,
              warehouseId: this.editUserModel.warehouseId,
              clientId: this.IsAgentProfileAvailable.clientId
            },
          };
          if (this.editUserModel.clientId) {
            request_data.isClient = true;
            request_data.clientId = this.userRoles.clientId;
          }
          // console.log("request_data | ", request_data)
          this.updateClientUser(request_data).then(
            (response) => {
              this.loading = false;
              if (response.status === 200) {
                this.$store.dispatch("distroCenter/FetchDistroCenters", { limit: -1 });
                this.$store.dispatch("generic/FetchClients", { perPage: -1 });
                this.$store.dispatch("generic/FetchUsers", { perPage: -1 });
                this.$store.dispatch("generic/FetchWarehouses", { limit: -1 });
                this.editUserVisible = false;
                this.showSuccessAlert("User profile updated successfully");
              } else {
                this.showErrorAlert(response.data.messages);
              }
            },
            (error) => {
              this.loading = false;
              this.showErrorAlert(JSON.stringify(error));
            }
          );
        } else {
          // console.log('error submit!!');
          this.loading = false;
          return false;
        }
      });
    },

    handleChangePasswordSubmit() {
      this.$refs.changePasswordForm.validate((valid) => {
        if (valid) {
          if (
            this.changePassswordModel.newPassword !==
            this.changePassswordModel.confirmPassword
          ) {
            // this.changePasswordVisible = false
            this.showErrorAlert("Password do not match");
          } else {
            this.loading = true;
            let request_data = {
              userId: this.selectedUser.id,
              data: {
                password: this.changePassswordModel.newPassword,
              },
            };

            // console.log("request_data | ", request_data)

            this.changeUserPassword(request_data).then(
              (response) => {
                this.loading = false;
                if (response.status === 200) {
                  this.getClientUsers();
                  this.changePasswordVisible = false;
                  this.showSuccessAlert("User password changed successfully");
                } else {
                  this.showErrorAlert(response.data.messages);
                }
              },
              (error) => {
                this.loading = false;
                this.showErrorAlert(JSON.stringify(error));
              }
            );
          }
        } else {
          // console.log('error submit!!');
          this.loading = false;
          return false;
        }
      });
    },
    showSuccessAlert(message) {
      this.$notification["success"]({
        message: message,
      });
    },
    showErrorAlert(message) {
      this.$notification["error"]({
        message: message,
      });
    },
    handleTableChange(pagination) {
      this.tableLoading = true;
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.params.page = pagination.current;
      this.params.perPage = pagination.pageSize;

      this.getClientUsersRequests(this.params).then(
        (response) => {
          this.tableLoading = false;
          // console.log('response  | ', response)
          if (response.status === 200) {
            const pagination = { ...this.pagination };
            pagination.total = response.data.totalRecords;
            let result = [];
            if (response.data.data.length !== 0) {
              result = response.data.data;
            }
            let finalUserRequestList = [];

            result.forEach((request) => {
              let userObject = {};
              userObject["key"] = request.id;
              userObject["name"] = request.name;
              userObject["phoneNumber"] = request.phoneNumber;
              (userObject["email"] = request.email),
                (userObject["gender"] = request.gender);
              userObject["status"] = request.isActive;
              userObject["createdAt"] = moment(request.createdAt).format(
                "DD-MMM-YYYY"
              );

              // orderRquestObject['action'] = request

              finalUserRequestList.push(userObject);
            });
            this.users = finalUserRequestList;
            this.pagination = pagination;
          } else {
            this.tableLoading = false;
            // console.log("Error | ", response);
          }
        },
        (error) => {
          this.tableLoading = false;
          console.log("Error | ", error);
        }
      );
    },
    getClientUsers() {
      this.tableLoading = true;

      this.getClientUsersRequests(this.params).then(
        (response) => {
          this.tableLoading = false;
          console.log('response  | ', response)
          if (response.status === 200) {
            const pagination = { ...this.pagination };
            pagination.total = response.data.totalRecords;
            let result = [];
            if (response.data.data.length !== 0) {
              result = response.data.data;
            }
            let finalUserRequestList = [];

            result.forEach((request) => {
              let userObject = {};
              userObject["key"] = request.id;
              userObject["name"] = request.name;
              userObject["phoneNumber"] = request.phoneNumber;
              (userObject["email"] = request.email),
                (userObject["gender"] = request.gender);
              userObject["status"] = request.isActive;
              userObject["createdAt"] = moment(request.createdAt).format(
                "DD-MMM-YYYY"
              );
              userObject["action"] = request;

              // orderRquestObject['action'] = request

              finalUserRequestList.push(userObject);
            });
            this.users = finalUserRequestList;
            this.pagination = pagination;
          } else {
            this.tableLoading = false;
            // console.log("Error | ", response);
          }
        },
        (error) => {
          this.tableLoading = false;
          console.log("Error | ", error);
        }
      );
    },
    async FetchRetailers() {
      this.loading = true
      const res = await this.$store.dispatch("getAllRetailers");
      this.loading = false
      if (res.status === 200) {
        // console.log("retailCenters", res.data);
        this.retailCenters = res.data.data;
      }
    },
  },
  created() {
    this.getClientUsers();
  },
  mounted() {
    this.FetchRetailers();
    this.$store.dispatch("distroCenter/FetchDistroCenters", { limit: -1 });
    this.$store.dispatch("role/FetchUserRoles");
    this.$store.dispatch("generic/FetchClients", { perPage: -1 });
    this.$store.dispatch("generic/FetchUsers", { perPage: -1 });
    this.$store.dispatch("generic/FetchWarehouses", { limit: -1 });
  },
};
</script>

<style scoped>
.actions {
  display: flex;
  justify-content: space-between;
}
.ant-table-wrapper {
  zoom: 1;
  background: #fff;
  margin-bottom: 30px;
}
.customerTable >>> .ant-table-thead th {
  background: #c7c7c763;
  height: 63px;
}

.customerTable >>> .ant-pagination-item-active {
  background: #418a49;
  border-color: #418a49;
}

.customerTable >>> .ant-pagination-item-active a {
  color: #fff;
}
.customerTable >>> .ant-table-pagination {
  float: none;
  margin: 16px 0;
  display: flex;
  justify-content: center;
}
a {
  color: #418a49;
}
a:hover {
  color: #418a49;
}
button:hover {
  color: #418a49;
  outline-color: #418a49;
  border-color: #418a49;
}

button {
  color: #418a49;
  outline-color: #418a49;
  border-color: #418a49;
}

card-container {
  background: none;
  overflow: hidden;
  /* padding: 24px; */
}
.disabledIcon {
  opacity: 0.5;
  cursor: not-allowed;
}
.card-container > .ant-tabs-card > .ant-tabs-content {
  height: 120px;
  margin-top: -16px;
}

.card-container > .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
  background: #fff;
  padding: 16px;
}

.card-container
  >>> .ant-tabs.ant-tabs-card
  .ant-tabs-card-bar
  .ant-tabs-tab-active {
  height: 40px;
  color: #98c14b;
  background: #e5efe7;
  border-color: #e5efe7;
  border-bottom: 1px solid #98c14b;
}
.card-container >>> .ant-tabs-tab {
  height: 40px;
  margin: 0;
  width: 217px;
  margin-right: 2px;
  padding: 0 16px;
  line-height: 38px;
  background: #fafafa;
  border: 1px solid #e8e8e8;
}
.card-container >>> .ant-tabs-tab:hover {
  color: #98c14b;
  /* background: #e5efe7; */
}

.card-container >>> .ant-badge-count {
  z-index: auto;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  color: #fff;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
  text-align: center;
  background: #98c14b;
  border-radius: 10px;
  box-shadow: 0 0 0 1px #fff;
}



.card-container>>>.ant-tabs-card>.ant-tabs-bar {
  border: none;
}

.card-container>>>.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab {
  height: 40px;
  color: #111827;
  background: transparent;
  border-radius: 8px;
  max-width: 18%;
  margin-right: 12px;
}


.card-container>>>.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
  height: 40px;
  color: #fff;
  background: #418a49;
  border-bottom: none;
  border-radius: 8px;
  max-width: 18%;
}


</style>